// Native
import {Component, HostBinding, OnDestroy, OnInit} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { finalize, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

// Services
import { AuthService} from '../../../resources/services/auth.service';
import { NotifyService } from '../../../resources/services/notify.service';

// Modules
import { ValidateService } from "../../../resources/modules/validate/validate.service";

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html'
})
export class SignupComponent implements OnInit, OnDestroy {

  authForm: FormGroup;
  submitEnabled: boolean = true;

  @HostBinding('class') classes: string = 'h-flex-full';

  unSubscriber: Subject<unknown> = new Subject<unknown>();

  constructor(private _authService: AuthService,
              private _notifyService: NotifyService,
              private _validateService: ValidateService) {}

  ngOnInit() {
    this.initForm();
  }

  ngOnDestroy() {
    this.unSubscriber.next();
    this.unSubscriber.complete();
  }

  initForm() {
    this.authForm = new FormGroup({
      email: new FormControl(null, [
        Validators.required,
        Validators.pattern(RegExp(this._validateService.validateEmail().regex))
      ]),
      password: new FormControl(null, [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(20),
      ]),
      confirmPassword: new FormControl(null, [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(20),
      ]),
    });
  }

  onSubmit(form) {
    if (form.valid && form.enabled) {
      const {password, confirmPassword} = form.value;

      if (password !== confirmPassword)
        return this._notifyService.passNotMatch();

      setTimeout(() => { form.disable() });;
      this.submitEnabled = false;

      this._authService.signUp(form.value)
        .pipe(
          takeUntil(this.unSubscriber),
          finalize(() => {
            form.enable();
            this.submitEnabled = true;
          })
        ).subscribe();
    }
    else
      this._notifyService.incorrectData();
  }

}
